var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_471_6337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00006 17.0625C5.10006 17.0625 1.93506 13.89 1.93506 9.99755C1.93506 6.10505 5.10006 2.92505 9.00006 2.92505C9.80256 2.92505 10.5826 3.03755 11.3326 3.27005C11.6326 3.36005 11.7976 3.67505 11.7076 3.97505C11.6176 4.27505 11.3026 4.44005 11.0026 4.35005C10.3651 4.15505 9.69006 4.05005 9.00006 4.05005C5.72256 4.05005 3.06006 6.71255 3.06006 9.99005C3.06006 13.2675 5.72256 15.93 9.00006 15.93C12.2776 15.93 14.9401 13.2675 14.9401 9.99005C14.9401 8.80505 14.5951 7.66505 13.9426 6.69005C13.7701 6.43505 13.8376 6.08255 14.1001 5.91005C14.3551 5.73755 14.7076 5.80505 14.8801 6.06755C15.6601 7.23005 16.0726 8.58755 16.0726 9.99755C16.0651 13.89 12.9001 17.0625 9.00006 17.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0973 4.55241C11.9398 4.55241 11.7823 4.48491 11.6698 4.35741L9.50234 1.86741C9.29984 1.63491 9.32234 1.27491 9.55484 1.07241C9.78734 0.869912 10.1473 0.892412 10.3498 1.12491L12.5173 3.61491C12.7198 3.84741 12.6973 4.20741 12.4648 4.40991C12.3673 4.50741 12.2323 4.55241 12.0973 4.55241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57016 6.39741C9.39766 6.39741 9.22516 6.31491 9.11266 6.16491C8.93266 5.91741 8.98516 5.56491 9.23266 5.37741L11.7602 3.53241C12.0077 3.34491 12.3602 3.40491 12.5477 3.65241C12.7352 3.89991 12.6752 4.25241 12.4277 4.43991L9.90016 6.29241C9.80266 6.36741 9.69016 6.39741 9.57016 6.39741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_471_6337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButton);
export default __webpack_public_path__ + "static/media/resetButton.c52fe57f654dae7178149c371bd51f03.svg";
export { ForwardRef as ReactComponent };